import "./resource.css";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Box, Button, CircularProgress } from "@mui/material";
import Shift from "../../components/Shift/Shift";
import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import Clients from "../Modal/Clients/AddClients";

const ResourceTrackerReadMode = ({
  days,
  gridData,
  length,
  setLength,
  connection,
  isConnected,
  clients,
  getClients
}: any) => {
  const [open, setOpen] = useState(false);
  const [hide, setHide] = useState(false);

  const addNewRow = () => {
    setLength((prevLength: any) => {
      const newLength: any = prevLength + 1;
      return newLength;
    });
  };

  const reorderedDays = [...days.slice(-1), ...days.slice(0, -1)];

  return (
    <>
      {!isConnected && (
        <div className="overlay">
          <Box className="loading-container">
            <CircularProgress className="loading-spinner" />
          </Box>
        </div>
      )}
      <div className="grid-container">
        {reorderedDays.map((day: any, index: any) => (
          <div
            key={index}
            className={`grid-header ${index === 0 && hide && "sticky-client"}`}
            style={{ backgroundColor: "#ccf1b8" }}
          >
            {index === 0 ? "Clients" : format(day.day, "EEEE, dd MMMM yyyy")}
          </div>
        ))}
        {Array.from({ length: length }).map((_, rowIndex) =>
          reorderedDays.map((day: any, shiftedColIndex: number) => {
            const colIndex = (shiftedColIndex + 7) % days.length;
            const clientInfo = clients.find(
              (client: any) =>
                rowIndex >= client.startRow - 1 && rowIndex <= client.endRow - 1
            );
            return (
              <div
                key={`${colIndex}-${rowIndex}`}
                className={`grid-item ${
                  colIndex === 7 && hide && "sticky-client"
                } no-hover-effect
                ${colIndex === 7 && "client-info"}`}
                style={{
                  ...(shiftedColIndex === 0 && {
                    backgroundColor: clientInfo?.color,
                  }),
                }}
              >
                {!gridData[`${colIndex}-${rowIndex}`] && (
                  <div style={{ textAlign: "right" }}>
                    {colIndex === 7 ? (
                      rowIndex === clientInfo?.startRow - 1 ? (
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: 600,
                            fontSize: 20,
                          }}
                        >
                          {clientInfo ? `${clientInfo.clientName}` : ""}
                        </div>
                      ) : null
                    ) : (
                      `${rowIndex + 1}, ${colIndex + 1}`
                    )}
                  </div>
                )}
                {gridData[`${colIndex}-${rowIndex}`] && (
                  <>
                    <div>
                      <Shift
                        gridData={gridData}
                        colIndex={colIndex}
                        rowIndex={rowIndex}
                        day={day}
                        readMode={true}
                      />
                    </div>
                  </>
                )}
              </div>
            );
          })
        )}
        <div className="button">
          <Button
            variant="outlined"
            startIcon={
              <FontAwesomeIcon icon={faPlus} size={"5x"} color="#e39865" />
            }
            onClick={addNewRow}
            size="large"
            style={{
              width: "10px",
              borderColor: "black",
              color: "black",
            }}
          />
        </div>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          getClients();
        }}
        maxWidth={false}
        sx={{ zIndex: 2 }}
        slotProps={{
          paper: {
            className: "add-modal",
            sx: { m: 0, maxWidth: "none", maxHeight: "none" },
          }
        }}
      >
        <Clients
          connection={connection}
          isConnected={isConnected}
          hide={hide}
          setHide={setHide}
        />
      </Dialog>
    </>
  );
};

export default ResourceTrackerReadMode;
